"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paragraphs = void 0;
const react_1 = __importDefault(require("react"));
const view_1 = require("../html-widget/view");
const themed_text_1 = require("../themed-text");
const styles_1 = require("./styles");
const Paragraphs = (props) => {
    const { paragraphs } = props;
    const paragraphSegments = paragraphs === null || paragraphs === void 0 ? void 0 : paragraphs.map((paragraph, index) => {
        var _a;
        return (react_1.default.createElement(react_1.default.Fragment, { key: index },
            react_1.default.createElement(themed_text_1.ThemedParagraph, { font: (_a = props.fontSize) !== null && _a !== void 0 ? _a : 'base' }, (0, view_1.SafeHtmlParse)(paragraph))));
    });
    return react_1.default.createElement(styles_1.StyledParagraphs, null, paragraphSegments);
};
exports.Paragraphs = Paragraphs;
